import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography, Button, Paper, useTheme } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ButtonChoice from './ButtonChoice';
import { StyledHeroSection } from '../SecondPage';
import PersonalizedBar from '../PersonalizedBar';
import theme from '../../muiTheme';
import { PromptContext } from '../PromptContext';

const SkillPracticePage = () => {
  const { subject } = useParams<{ subject?: string }>();
  const context = useContext(PromptContext);
  const isInQuestionMode = Boolean(context?.questionText);
  const theme = useTheme();

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      {!isInQuestionMode ? <StyledHeroSection /> : null}
      <PersonalizedBar />
      <Box sx={{ p: 0, maxWidth: '1600px', mx: 'auto', mt: 0 }}>
        
        <Paper elevation={1} sx={{ px: {xs: 1, sm: 3}, py: 0, mb: 1, bgcolor: theme.palette.background.default }}>
          {/*NOTE TO IVAN - Add instructions / guidance up top? 
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 3 }}>
            <Typography variant="h4">SAT Skill Practice</Typography>
          </Box>*/}
          <ButtonChoice />
        </Paper>
      </Box>
    </Box>
  );
};

export default SkillPracticePage;

//Removed on 4/7/2025 after adding a matching Return to Dashbaord button in PersonalizedBar.tsx:
//<Button variant="outlined" startIcon={<ArrowBackIcon />} onClick={() => navigate('/sat')}>
//              Back to Dashboard
//            </Button>